module.exports = __webpack_public_path__ + "img/40_64.450ec16a.png";